import { Check } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { useT } from "../i18n/useT";

export default function FounderLed() {
  const t = useT();
  return (
    <section id="about" className="py-24 sm:py-28 border-t border-ink-800/60">
      <div className="container-page grid gap-12 lg:grid-cols-[1fr_1fr] lg:items-start">
        <div>
          <SectionHeading eyebrow={t.founderLed.eyebrow} title={t.founderLed.title} />
          <p className="mt-6 text-base text-ink-300 leading-relaxed">
            {t.founderLed.p1Pre}{" "}
            <span className="text-ink-50 font-medium">SV4 Ventures</span>
            {t.founderLed.p1Mid}{" "}
            <span className="text-ink-50 font-medium">Sergio Píriz</span>
            {t.founderLed.p1Post}
          </p>
          <p className="mt-4 text-base text-ink-300 leading-relaxed">{t.founderLed.p2}</p>
        </div>
        <ul className="grid gap-3">
          {t.founderLed.points.map((p) => (
            <li
              key={p}
              className="flex items-start gap-3 rounded-lg border border-ink-800 bg-ink-900/50 p-4"
            >
              <Check className="mt-0.5 size-4 shrink-0 text-accent-500" />
              <span className="text-sm text-ink-100">{p}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
